import { createFileRoute } from '@tanstack/react-router'
import { BlockCallerIdsPage } from '@/features/admin/block-caller-ids'

export const Route = createFileRoute('/_authenticated/reseller/block-caller-ids')({
  component: () => <BlockCallerIdsPage scope='reseller' />,
})
